import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { BookOpenIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

// Layout
import LayoutWithOutNavBar from '../../components/layout/LayoutWithOutNavBar';

// Services
import { registerUser } from '../../services/userAPIService';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    
    if (password !== confirmPassword) {
      setError('Die Passwörter stimmen nicht überein');
      return;
    }
    
    try {
      await registerUser({ email, password });
      // Anstatt den Status zu ändern, navigieren wir zur Erfolgsseite
      // und übergeben die E-Mail-Adresse
      navigate('/register-success', { state: { email } });
    } catch (error) {
      setError(error.message || 'Registrierung fehlgeschlagen');
    }
  };

  return (
    <LayoutWithOutNavBar>
      <div className="min-h-screen bg-base-200">
        <div className="container mx-auto px-4 py-8 max-w-7xl">
          <Link
            to="/"
            className="btn btn-ghost btn-sm gap-2 mb-8 hover:bg-base-300"
          >
            <ArrowLeftIcon className="w-4 h-4" />
            Zurück
          </Link>

          <div className="flex flex-col items-center justify-center">
            {/* Branding Section */}
            <div className="text-center mb-8">
              <BookOpenIcon className="w-12 h-12 text-primary mx-auto mb-4" />
              <h1 className="text-3xl font-bold">
                Mein-SKS
              </h1>
            </div>

            {/* Register Card */}
            <div className="card w-full max-w-md bg-base-100 shadow-lg">
              <div className="card-body space-y-6">
                <h2 className="text-xl font-bold text-center">
                  Registrieren
                </h2>

                {error && (
                  <div className="alert alert-error">
                    <svg xmlns="http://www.w3.org/2000/svg" className="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span>{error}</span>
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="form-control">
                    <label className="label">
                      <span className="label-text font-medium">E-Mail</span>
                    </label>
                    <input 
                      type="email" 
                      placeholder="mail@beispiel.de"
                      className="input input-bordered bg-base-200 focus:bg-base-100" 
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-control">
                    <label className="label">
                      <span className="label-text font-medium">Passwort</span>
                    </label>
                    <input 
                      type="password" 
                      placeholder="••••••••"
                      className="input input-bordered bg-base-200 focus:bg-base-100" 
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <label className="label">
                      <span className="label-text-alt text-base-content/70">Mindestens 8 Zeichen</span>
                    </label>
                  </div>

                  <div className="form-control">
                    <label className="label">
                      <span className="label-text font-medium">Passwort bestätigen</span>
                    </label>
                    <input 
                      type="password" 
                      placeholder="••••••••"
                      className="input input-bordered bg-base-200 focus:bg-base-100" 
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>

                  <button 
                    type="submit" 
                    className="btn btn-primary w-full"
                  >
                    Konto erstellen
                  </button>

                  <div className="divider text-base-content/60">ODER</div>

                  <div className="text-center space-y-2">
                    <p className="text-base-content/70">Bereits registriert?</p>
                    <Link 
                      to="/login" 
                      className="btn btn-outline btn-secondary w-full"
                    >
                      Zum Login
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutWithOutNavBar>
  );
};

export default RegisterPage;
